import React from 'react';
import Static404 from './Static404';

const Smart404Router: React.FC = () => {
  // Simply show the new clean 404 page
  return <Static404 />;
};

export default Smart404Router;
